import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import "./login.css";
import logo from "../../assets/logo-admin.svg";
import { UserContext } from "../../contexts/user.context";
import { LoadingContext } from "../../contexts/loading.context";
import Swal from "sweetalert2";
import EfikaPlatformsHandler from "../../efika/efikaPlatformsHandler";

const Login = (props) => {

    const [userName, setUserName] = useState("");
    const [userPassword, setUserPassword] = useState("");

    const [user, setUser] = useContext(UserContext);
    const setShowLoading = useContext(LoadingContext)[1];

    const history = useHistory();

    const loginHandler = async () => {
        setShowLoading(true);
        const efikaPlatformsHandler = new EfikaPlatformsHandler()
        const response = await efikaPlatformsHandler.login(userName, userPassword)
        setShowLoading(false)
        try {
            if (response.status === 200) {
                if(!response.data.role.includes("ROLE_ADMIN") && !response.data.role.includes("ROLE_ADMINISTRADOR_SIN_PROFORMAS")){
                    Swal.fire({
                        title: "Error",
                        text: "Su usuario no cuenta con los permisos necesarios. Por favor contactar con soporte",
                        icon: "error",
                    })
                    return
                }
                const dataToSet = {
                    userId: response.data.username,
                    user_email: response.data.email,
                    name: response.data.first_name,
                    lastName: response.data.last_name,
                    permissions: response.data.role,
                    vendorId: response.data.additional_info.vendorId,
                    additional_info: response.data.additional_info
                }
                localStorage.setItem("userInformation", JSON.stringify(dataToSet))
                setUser(dataToSet)
                history.push("/home")
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Ha ocurrido un error, por favor verificar los datos ingresados.",
                    icon: "error",
                })
            }

        } catch (error) {
            console.log(error)

            Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error desconocido",
                icon: "error",
            })
        }
    }

    useEffect(() => {
        if (user !== null) {
            history.push("/home");
        }
    }, [user, history]);

    return (
        <div className="backgroundContainer">
            <div className="loginContainer">
                <img src={logo} alt="kakao-market-logo" style={{ width: "50%" }} />
                <div className="loginInputContainer">
                    <label className="loginInputLabel">Usuario</label>
                    <input
                        className="loginInput"
                        type="email"
                        id="user"
                        name="user"
                        value={userName}
                        onChange={(event) => setUserName(event.target.value)}
                    />
                </div>
                <div className="loginInputContainer">
                    <label className="loginInputLabel">Contraseña</label>
                    <input
                        className="loginInput"
                        type="password"
                        id="password"
                        name="password"
                        value={userPassword}
                        onChange={(event) => setUserPassword(event.target.value)}
                    />
                    <div className="passwordRecoveryContainer">
                        <span className="passwordRecovery" onClick={() => history.push("/resetPassword")}>¿Olvidaste tu contraseña?</span>
                    </div>
                </div>
                <div className="loginButtonContainer">
                    <button className="loginButton" onClick={loginHandler}>
                        INICIAR SESIÓN
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;
